import React, { useEffect, useState } from 'react';

const MUSIC_NOTES = ['♪', '♫', '♬', '♩', '♭', '♮', '♯'];
const MUSIC_SYMBOLS = ['🎵', '🎶', '🎼', '🎹', '🎸', '🎷', '🎺', '🎻'];

interface MusicNote {
  id: number;
  symbol: string;
  left: string;
  delay: number;
  duration: number;
  size: string;
  rotate: number;
}

interface EqualizerBar {
  id: number;
  left: string;
  width: string;
  height: string;
  duration: number;
  delay: number;
}

interface MusicSymbol {
  id: number;
  symbol: string;
  left: string;
  top: string;
  delay: number;
  duration: number;
  size: string;
}

const MusicBackground: React.FC = () => {
  const [notes, setNotes] = useState<MusicNote[]>([]);
  const [equalizerBars, setEqualizerBars] = useState<EqualizerBar[]>([]);
  const [symbols, setSymbols] = useState<MusicSymbol[]>([]);

  useEffect(() => {
    // Generate random music notes
    const generatedNotes = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      symbol: MUSIC_NOTES[Math.floor(Math.random() * MUSIC_NOTES.length)],
      left: `${Math.random() * 100}%`,
      delay: Math.random() * 10,
      duration: 15 + Math.random() * 15,
      size: `${Math.random() * 20 + 20}px`,
      rotate: Math.random() * 360
    }));
    setNotes(generatedNotes);

    // Generate equalizer bars
    const bars = Array.from({ length: 30 }, (_, i) => ({
      id: i,
      left: `${(i / 30) * 100}%`,
      width: `${Math.random() * 4 + 2}px`,
      height: `${Math.random() * 100 + 50}px`,
      duration: 1 + Math.random() * 2,
      delay: Math.random() * 2
    }));
    setEqualizerBars(bars);

    // Generate music symbols
    const generatedSymbols = Array.from({ length: 10 }, (_, i) => ({
      id: i,
      symbol: MUSIC_SYMBOLS[Math.floor(Math.random() * MUSIC_SYMBOLS.length)],
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      delay: Math.random() * 15,
      duration: 20 + Math.random() * 20,
      size: `${Math.random() * 30 + 30}px`
    }));
    setSymbols(generatedSymbols);
  }, []);

  return (
    <div className="music-bg">
      {/* Floating music notes */}
      {notes.map((note) => (
        <div
          key={note.id}
          className="music-note"
          style={{
            left: note.left,
            animationDelay: `${note.delay}s`,
            animationDuration: `${note.duration}s`,
            fontSize: note.size,
            transform: `rotate(${note.rotate}deg)`
          }}
        >
          {note.symbol}
        </div>
      ))}

      {/* Equalizer effect at the bottom */}
      {equalizerBars.map((bar) => (
        <div
          key={bar.id}
          className="equalizer-bar"
          style={{
            left: bar.left,
            width: bar.width,
            height: bar.height,
            animationDuration: `${bar.duration}s`,
            animationDelay: `${bar.delay}s`
          }}
        />
      ))}

      {/* Floating music symbols */}
      {symbols.map((symbol) => (
        <div
          key={symbol.id}
          className="music-symbol"
          style={{
            left: symbol.left,
            top: symbol.top,
            animationDelay: `${symbol.delay}s`,
            animationDuration: `${symbol.duration}s`,
            fontSize: symbol.size
          }}
        >
          {symbol.symbol}
        </div>
      ))}

      {/* Wave effect */}
      <div className="music-wave" />
    </div>
  );
};

export default MusicBackground;